<app-card-consulta 
  (update)="update.emit($event)" 
  [titulo]="titulo" 
  [idConsulta]='idConsulta' 
  [tipoConsulta]="tipoConsulta" 
  [codigoControle]="codigoControle"
  [status]="status"
  [msg]="statusMsg"
>

  <ng-container *ngIf="consulta">
      
    <ul class="card-list-striped py-1">
      <li>
        <span class="text-secondary">FAIXA/CLASSE:</span>
        <span class="text-uppercase">{{consulta?.texto || msgNull}}</span>
      </li>
      <li>
        <span class="text-secondary">CLASSIFICAÇÃO:</span>
        <span class="text-uppercase">{{consulta?.classificacao || msgNull}}</span>
      </li>
    </ul>

  </ng-container>

</app-card-consulta>